import english from './languages/en'
import italian from './languages/it'
import spanish from './languages/es'
import loadResources from './utils/loadResources'

export { english, italian, spanish, loadResources }
